import React from 'react';
import SidebarAdmin from '../../scenes/global/SidebarAdmin';
import SidebarSuperAdmin from '../../scenes/global/SidebarSuperAdmin';
import SidebarConsultant from '../../scenes/global/SidebarConsultant';
import SidebarUser from '../../scenes/global/SidebarUser';
import SidebarRepresentative from '../../scenes/global/SidebarRepresentative';

export default function SidebarManager({ access, isSidebar }) {
  const options = {
    super_admin: <SidebarSuperAdmin isSidebar={isSidebar} />,
    admin: <SidebarAdmin isSidebar={isSidebar} />,
    manager: <SidebarAdmin isSidebar={isSidebar} />,
    consultant: <SidebarConsultant isSidebar={isSidebar} />,
    user: <SidebarUser isSidebar={isSidebar} />,
    representative: <SidebarRepresentative isSidebar={isSidebar} />,
  };

  // retorna o componente de sidebar correspondente ao acesso do usuário
  return options[access];
}
